import React from 'react';
import Select, { MultiValue } from 'react-select';
import './multiselect.scss';
type Option = {
    label: string;
    value: string;
};

type Props = {
    onChange: (name: string, value: Array<string> ) => void;
    name: string;
    value?: Array<string>;
    options: Array<Option>;
    placeholder: string;
    error?: boolean;
    errorText?:string;
};

const InputMultiSelect: React.FC<Props> = ({ name, value=[], options, placeholder, onChange, error, errorText }) => {
    const [selected, setSelected] = React.useState<Array<Option> | undefined>();

    React.useEffect(() => {
        const newValue:Array<Option>=[];
        options.forEach((element: Option)=> {
            if(value?.includes(element.value)) {
                newValue.push(element);
            }
        })
        setSelected(newValue);
    }, [value]);

    const handleChange = (options: MultiValue<Option>): void => {
        if (options) {
            const newValue: Array<string> = [];
            options.forEach((element: Option)=> {
                newValue.push(element.value);
            })
            onChange(name, newValue);
        }
    };
    return (
        <div className="multi-select-container">
            <Select
                onChange={handleChange}
                name={name}
                options={options}
                value={selected}
                placeholder={placeholder}
                classNamePrefix={error?  'error-select' : 'input-select'}
                isMulti={true}
            />
            {error && <p className="error-text">{errorText}</p>}
        </div>
    );
};

export default InputMultiSelect;
